<mat-icon class="svg-page_not_found" svgIcon="page-not-found"></mat-icon>
<div class="go-to-container">
    <button mat-stroked-button (click)="redirectToSelectClientPage()" color="black" i18n>Go to Select Client page</button>
    @if(hasClientId){
    <button mat-stroked-button (click)="redirectToDefaultPage()" color="black" i18n>Go to Home
        page</button>
    }
</div>